import React from 'react'

export const doc = {
  path: (
    <>
      <path
        d="M9 7.87476C8.44772 7.87476 8 8.32247 8 8.87476C8 9.42704 8.44772 9.87476 9 9.87476H15C15.5523 9.87476 16 9.42704 16 8.87476C16 8.32247 15.5523 7.87476 15 7.87476H9Z"
        fill="currentColor"
      />
      <path
        d="M9 11.8748C8.44772 11.8748 8 12.3225 8 12.8748C8 13.427 8.44772 13.8748 9 13.8748H17C17.5523 13.8748 18 13.427 18 12.8748C18 12.3225 17.5523 11.8748 17 11.8748H9Z"
        fill="currentColor"
      />
      <path
        d="M8 16.8748C8 16.3225 8.44772 15.8748 9 15.8748H15C15.5523 15.8748 16 16.3225 16 16.8748C16 17.427 15.5523 17.8748 15 17.8748H9C8.44772 17.8748 8 17.427 8 16.8748Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4.87476C3 2.66562 4.79086 0.874756 7 0.874756H19C21.2091 0.874756 23 2.66562 23 4.87476V20.8748C23 23.0839 21.2091 24.8748 19 24.8748H7C4.79086 24.8748 3 23.0839 3 20.8748V4.87476ZM7 2.87476H19C20.1046 2.87476 21 3.77019 21 4.87476V20.8748C21 21.9793 20.1046 22.8748 19 22.8748H7C5.89543 22.8748 5 21.9793 5 20.8748V4.87476C5 3.77019 5.89543 2.87476 7 2.87476Z"
        fill="currentColor"
      />
    </>
  ),
  viewBox: '0 0 25 25',
}
